const Profile = () => {
  const fullName = localStorage.getItem("fullName");
  const email = localStorage.getItem("email");
  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">Profile </h3>
      </div>
      <div className="col-md-12 grid-margin stretch-card">
        <div className="col-md-8  ">
          <div className="card">
            <div className="card-body">
              <form className="pt-3">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label font-weight-medium">
                    Name
                  </label>
                  <div className="col-sm-9">
                    <input
                      className="form-control form-control-sm"
                      value={fullName}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label font-weight-medium">
                    Email
                  </label>
                  <div className="col-sm-9">
                    <input
                      className="form-control form-control-sm"
                      value={email}
                      readOnly
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
